export default{
  methods: {
    numberFormat: function (price) {
      return price.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },
    seconds_to_record: function (second) {
      // console.log('---- seconds_to_record() ----')
      // console.log(second)
      var hour
      var min
      var sec
      if (second > 0) {
        hour = Math.floor(second / 3600)
        min = Math.floor(second / 60) - hour * 60
        sec = second % 60
      } else {
        hour = Math.ceil(second / 3600)
        min = Math.abs(Math.ceil(second / 60) - hour * 60)
        sec = Math.abs(second % 60)
      }
      // console.log(hour + ' / ' + min + ' / ' + sec)

      if (isNaN(this.zp(2, sec))) {
        return '-'
      }
      return `${this.zp(2, hour)}h${this.zp(2, min)}m${this.zp(2, sec)}s`
    },
    // zero_padding
    zp: function (length, num) {
      return num.toString().padStart(length, '0')
    }
  }
}



// WEBPACK FOOTER //
// ./src/utility.js